import PropTypes from 'prop-types';
import React from 'react';

import { Column, Table } from 'fixed-data-table-2';

import SortableHeaderCell from '../../components/SortableHeaderCell/SortableHeaderCell';
import TableMixin from '../../components/TableMixin/TableMixin';
import TextCell from '../../components/TextCell/TextCell';
import CBurstAlertsSettings from '../../containers/CAlertsSettings/CBurstAlertsSettings';
import CSelectCell from '../../containers/CSelectCell/CSelectCell';
import { DateType } from '../../containers/UIhelper/UIDateFormater';
import useProjectTimezone from '../../hooks/useProjectTimeZone';

require('../AlertsTable/AlertsTable.scss');

function BurstAlertsTable(props, context) {
  const {
    items,
    indexMap,
    selectedFeature,
    localSortProp,
    pHeight,
    pWidth,
    timeZone,
    rowClickEvent,
    t,
  } = props;
  const projectTimezone = useProjectTimezone();

  const [goToRow, setGoToRow] = React.useState(null);

  React.useEffect(() => {
    if (selectedFeature) {
      const rowIndex = items.findIndex((bAlert) => bAlert.id === selectedFeature.id);
      setGoToRow(rowIndex);
    }
  }, [selectedFeature]);

  function getRowClassName(rowIndex) {
    if (!selectedFeature) {
      return '';
    }
    const rowItem = items[rowIndex];
    console.log('selectedFeature', selectedFeature, 'rowItem', rowItem);
    return rowItem?.ID === selectedFeature.ID ? 'active-row' : '';
  }

  const totalItemsStyle = {
    float: 'right',
    padding: '2px 8px',
  };

  return (
    <div>
      <Table
        maxHeight={pHeight - 93}
        width={pWidth}
        rowsCount={items.length}
        rowHeight={30}
        headerHeight={30}
        onRowClick={rowClickEvent}
        rowClassNameGetter={getRowClassName}
        scrollToRow={goToRow}
      >
        <Column
          columnKey='id'
          width={95}
          flexGrow={1}
          header={<SortableHeaderCell sortTable={localSortProp} />}
          cell={<TextCell data={items} field='id' />}
        />
        <Column
          columnKey='device_id'
          width={95}
          flexGrow={1}
          header={<SortableHeaderCell sortTable={localSortProp} />}
          cell={<TextCell data={items} field='device_id' />}
        />
        <Column
          columnKey='sensor_id'
          width={95}
          flexGrow={1}
          header={<SortableHeaderCell sortTable={localSortProp} />}
          cell={<TextCell data={items} field='sensor_id' />}
        />
        {props.user.isAQS && (
          <Column
            columnKey='create_date'
            width={95}
            flexGrow={1}
            header={<SortableHeaderCell sortTable={localSortProp} />}
            cell={
              <TextCell
                data={items}
                field='create_date'
                dateType={DateType.DATE}
                additional={timeZone}
                projectTimezone={projectTimezone}
              />
            }
          />
        )}
        <Column
          columnKey='last_event_date'
          width={120}
          flexGrow={1}
          header={<SortableHeaderCell sortTable={localSortProp} />}
          cell={
            <TextCell
              data={items}
              field='last_event_date'
              dateType={DateType.DATE_AND_TIME}
              additional={timeZone}
              projectTimezone={projectTimezone}
            />
          }
        />
        <Column
          columnKey='alert_state'
          width={95}
          flexGrow={1}
          header={<SortableHeaderCell sortTable={localSortProp} />}
          cell={
            <CSelectCell
              data={items}
              field='alert_state'
              options={props.optionList.options.AlertStateNoise}
              dummyPropForUpdate={localSortProp}
            />
          }
        />
        <Column
          columnKey='last_event_rms'
          width={70}
          flexGrow={1}
          header={<SortableHeaderCell sortTable={localSortProp} />}
          cell={<TextCell data={items} field='last_event_rms' />}
        />
        <Column
          columnKey='last_threshold_rms'
          width={70}
          flexGrow={1}
          header={<SortableHeaderCell sortTable={localSortProp} />}
          cell={<TextCell data={items} field='last_threshold_rms' />}
        />
        <Column
          columnKey='test_duration_min'
          width={70}
          flexGrow={1}
          header={<SortableHeaderCell sortTable={localSortProp} />}
          cell={<TextCell data={items} field='test_duration_min' />}
        />
        <Column
          columnKey='alert_count'
          width={60}
          flexGrow={1}
          header={<SortableHeaderCell sortTable={localSortProp} />}
          cell={<TextCell data={items} field='alert_count' />}
        />
        <Column
          columnKey='Comment'
          headerClassName='comment'
          cellClassName='comment'
          width={120}
          flexGrow={3}
          header={t('comment')}
          cell={<TextCell data={items} field='Comment' />}
        />
      </Table>

      {items && items.length > 0 && (
        <span style={totalItemsStyle}>
          {t('selected_selectedindex_total_total', {
            selectedIndex:
              indexMap[selectedFeature && selectedFeature.ID] + 1 || 0,
            total: items.length,
          })}
        </span>
      )}
    </div>
  );
}

BurstAlertsTable.contextTypes = {
  t: PropTypes.func.isRequired,
};

const burstAlertsTable = TableMixin(BurstAlertsTable, CBurstAlertsSettings);
export default burstAlertsTable;
